import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function TreeProcessingOverlay({ groupId, overlay }) {
  const [t] = useTranslation()

  return (
    <DialogOverlay {...overlay} title={t('tw-pedigree.tree-processing.heading')} nonClosable>
      <Paragraph size="sm">{t('tw-pedigree.tree-processing.description')}</Paragraph>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          {/* For a page refresh to happen this button needs to be external */}
          <Button data-testid="view-fs-tree-button" external to="/tree/pedigree/?treeId=PRIVATE">
            {t('tw-pedigree.view-fs-tree.action')}
          </Button>
          {groupId && (
            <Button
              data-testid="view-tree-details-button"
              external
              to={`/groups/research-tree/${groupId}`}
              emphasis="high"
            >
              {t('tw-pedigree.view-tree-details.action')}
            </Button>
          )}
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
